export const FIRST_DAY_OF_DRAFT = "FirstDayOfDraft";
